export default __webpack_public_path__ + "static/media/data.fd075672.svg";